export default __webpack_public_path__ + "static/media/093-down-arrow-1.bc132caa.png";